import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../services/axiosInstance";
import { API_ENDPOINTS } from "../services/api/apiConfig";

export const useDoctorSpecialties = () => {
    return useQuery<string[]>({
        queryKey: ['doctors', 'specialties'],
        queryFn: async () => {
            const response = await axiosInstance.get(API_ENDPOINTS.USERS.DOCTORS.SPECIALTIES);
            // Ensure unique and clean values
            return Array.from(
                new Set(response.data.filter((s: string) => s && s.trim() !== ""))
            ) as string[];
        },
        staleTime: 1000 * 60 * 60, // Specialties don't change often (1 hour)
    });
};
